import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/var/lib/jenkins/jobs/app-styleguide/workspace/src/templates/page.js"
import { Button, EnhancedButton } from 'module-tsl-ui-elements';
import ButtonWithDocgen from 'module-tsl-ui-elements/with-docs/buttons/Button';
import CopyableSnippet from '../../../components/utils/CopyableSnippet';
import pkg from 'module-tsl-ui-elements/package.json';
import PropsTable from '../../../components/propsTable';
import Version from '../../../components/version';
import LiveCode from '../../../components/liveCode';
import ButtonOverview from './ButtonOverview';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)}
             components={components}>


<ButtonOverview />
<MDXTag name="h3" components={components} props={{"id":"icons"}}><MDXTag name="a" components={components} parentName="h3" props={{"href":"#icons","aria-label":"icons permalink","class":"anchor"}}></MDXTag>{`icons`}</MDXTag>
<MDXTag name="p" components={components}>{`To use the icons you just have to pass `}<code className="language-text">icon="name"</code>
{` and then you will need to specify the css for that icon, with the color matching the theme of the button.`}</MDXTag>
<CopyableSnippet code={`.tds-btn--primary .icon--name {
  @include generate-icon(tds-name, $color-white);
}`} />
<MDXTag name="p" components={components}>{`The colors for the themes are:`}</MDXTag>
<div style={{ marginBottom: 10 }}>
<span>primary:</span>
<CopyableSnippet code="$color-white" />
</div>
<div style={{ marginBottom: 10 }}>
<span>secondary, tertiary:</span>
<CopyableSnippet code="$color-cornflower-blue-20k" />
</div>
<div style={{ marginBottom: 10 }}>
<span>primary-monotone:</span>
<CopyableSnippet code="$color-white" />
</div>
<div style={{ marginBottom: 10 }}>
<span>secondary-monotone, tertiary-monotone:</span>
<CopyableSnippet code="$color-k-70" />
</div>
<div style={{ marginBottom: 10 }}>
<span>primary-inverse:</span>
<CopyableSnippet code="$color-k-87" />
</div>
<div style={{ marginBottom: 10 }}>
<span>secondary-inverse, tertiary-inverse:</span>
<CopyableSnippet code="$color-white" />
</div>
<div style={{ marginBottom: 10 }}>
<span>primary-warning:</span>
<CopyableSnippet code="$color-white" />
</div>
<div style={{ marginBottom: 10 }}>
<span>secondary-warning, tertiary-warning:</span>
<CopyableSnippet code="$color-french-rose-20k" />
</div>
<MDXTag name="h3" components={components} props={{"id":"example-editable"}}><MDXTag name="a" components={components} parentName="h3" props={{"href":"#example-editable","aria-label":"example editable permalink","class":"anchor"}}></MDXTag>{`example (editable)`}</MDXTag>
<LiveCode
  code={`
  <React.Fragment>
    <Button>Click me</Button>
    <br />
    <br />
    <Button icon="plus">Click me</Button>
    <br />
    <br />
    <EnhancedButton>
      <Button
        onClick={() => console.log('clicked icon')}
        icon="remove"
        size="sm"
      />
      <Button
        onClick={() => console.log('clicked button')}
      >
        Ctay (8)
      </Button>
    </EnhancedButton>
  </React.Fragment>
  `}
  scope={{ Button, EnhancedButton }}
/>
<PropsTable data={ButtonWithDocgen.__docgenInfo} />
<Version name={'npm i module-tsl-ui-elements --save'} version={pkg.version} />
           </MDXTag>
  }
}

export const _frontmatter = {};

  